<script>
import { mixinJleague } from './mixin/utility'
import { mixinJleagueClient } from './mixin/jleague_client'
import JleagueHeader from './components/JleagueHeader'
import JleagueFooter from './components/JleagueFooter'
import SignupForm from './components/SignupForm'

export default {
    name: 'SignupForFlp',
    components: {
        'jleague-header': JleagueHeader,
        'jleague-footer': JleagueFooter,
        'signup-form': SignupForm,
    },
    mixins: [mixinJleague, mixinJleagueClient],
    data() {
        return {
            password: '',
            errorMessage: '',
        }
    },
    computed: {
        flpToken: function(){
            // FLPのときクエリパラメータから取得する
            const url = location.href;
            return mixinJleague.methods.getUrlParamByKey(url, 'token');
        },
        flpClientId: function(){
            // FLPのときクエリパラメータから取得する
            const url = location.href;
            return mixinJleague.methods.getUrlParamByKey(url, 'client_id');
        },
        flpJwtPayload: function(){
            if (!!this.flpToken) {
                const jwts = this.flpToken.split('.');
                if (jwts.length > 0) return JSON.parse(atob(jwts[1]));
            }

            return null;
        },
        flpClubCode: function(){
            return (this.flpJwtPayload && this.flpJwtPayload.club_cd)? this.flpJwtPayload.club_cd: null;
        },
        isError: function(){
            return this.errorMessage !== '';
        },
    },
    methods: {
        setPassword: function(value){
            this.password = value;
        },
        /**
         * FLPのときは `mixinJleagueClient` の `setClientId` を override してプロパティに設定する
         */
        setClientId() {
            this.clientId = this.flpClientId
        },
    },
}
</script>
